import { SmartFilter } from '@Portal/models/smartFilters/SmartFilter';
import { ViewMode } from '@Portal/models/ViewMode';

// Color when a program is inactive
export const inactiveColor = '#D3D3D3';

// old colors
export const neutralColor = '#7F7466';
export const detractorColor = '#D4002B';
export const promoterColor = '#0C8A65';

// new colors
export const newPromoterColor = '#5FC0A4';
export const newNeutralColor = '#D58D31';
export const newDetractorColor = '#D36D82';

export const resonateColor = '#C73362';
export const blankText = '[blank]';

export const deepLinkImagePath = `/dataviz/deepLink/deep_link_button.svg`;
export const deepLinkImageWhitePath = `/dataviz/deepLink/deep_link_button_white.svg`;
export const legendImagePath = `/dataviz/npsbarchart/`; // The legendpath to retrieve legend images

export const statusSortOrder = ['None', 'Pending', 'In Progress', 'In-Progress', 'Assigned', 'Completed', 'Closed']; // make this into Enum?
export enum ChartMode {
  // this visual has a selection
  Selection = 'Selection',
  // one of the visuals has a selection
  PrimaryAndSecondary = 'PrimaryAndSecondary',
  // no visuals have selections
  PrimaryOnly = 'PrimaryOnly',
}

export enum SupportedFont {
  OpenSans = 'Open Sans',
  SansSerif = 'sans-serif',
}

export const getFont = (font: SupportedFont) =>
  (Object.values(SupportedFont) as string[]).includes(font) ? font : SupportedFont.SansSerif; // SansSerif is the default font

export enum CustomerJourneyFriendlyName {
  TouchpointLineChart = 'Journey Map',
  SingleBarStackChartWithHero = 'Responses',
  ResponseStateCounter = 'Status',
}

export const getCustomerJourneyAppInsightArgs = (friendlyName: CustomerJourneyFriendlyName, args: string[]) =>
  [friendlyName.toString()].concat(args);

export enum ProductEmailType {
  SocialCX = 'SocialCX',
  CustomerJourney = 'CustomerJourney',
  Benchmarking = 'Benchmarking',
}

export class ProductEmailRequest {
  ProgramName? = '';
  ProductEmailType = ProductEmailType.SocialCX;
}

export interface VisualRenderingItem extends VisualDefinition {
  primary: Record<string, TemplateBindingItem>;
  secondary: Record<string, TemplateBindingItem>;
  update?: (primary?: Record<string, TemplateBindingItem>, secondary?: Record<string, TemplateBindingItem>) => void;
}

export interface VisualsViewModel {
  settings: Record<string, any>;
  breadcrumb: BreadcrumbDefinition;
  definitions: VisualDefinition[];
  layout: Record<string, VisualLayoutPoint>[];
  advancedLayout: VisualAdvancedLayout;
  layoutFilter: VisualLayoutFilter[];
  hasRecordsToDisplay: boolean;
}

export interface BreadcrumbDefinition {
  name: string;
  templateBindings: Record<string, TemplateBindingItem>;
}

export interface TemplateBindingItem {
  filterKey: string;
  content: any;
  currentPeriod: DateRangeBounds;
  previousPeriod: DateRangeBounds;
  currentRecordCount: number;
  previousRecordCount: number;
  deepLinkParams?: DeepLinkParams;
}

export interface DeepLinkParams {
  enableDeepLink?: boolean;
  measureKey?: string;
  myDataModule?: string;
  subProfile?: string;
  configFilters?: SmartFilter[];
  viewMode?: ViewMode;
}

export interface DateRangeBounds {
  startDateTime: string;
  endDateTime: string;
}

export interface VisualDefinition {
  name: string;
  width: number;
  height: number;
  template: string;
  templateBindings: Record<string, TemplateBindingItem>;
}

export interface VisualLayoutPoint {
  x: number;
  y: number;
}

export interface VisualAdvancedLayout {
  rowMargins: number[][];
  layoutGroups: string[][];
  roleLayouts: RoleLayout[];
}

export interface RoleLayout {
  layout: Record<string, VisualLayoutPoint>[];
  appliesToRoles: string[];
}

export interface VisualLayoutFilter {
  name: string;
  items: string[];
}
